import {
  Alert,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Col, Container, Row } from "react-bootstrap";
import React, { Fragment, useEffect, useState } from "react";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";
import {
  fetchActiveCustomer,
  fetchAddPointsCustomer,
  fetchChangeSectorCustomer,
  fetchCustomerList,
  fetchDeactiveCustomer,
} from "../actions/customer";
import {
  statusAdministrationRender,
  statusRender,
  statusSectorRender,
} from "../utils/cellRenderTable";
import { useDispatch, useSelector } from "react-redux";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import CustomModal from "../components/Common/Modal/CustomModal";
import InputField from "../components/Admin/Reusable/InputField";
import { useTranslation } from "react-i18next";
import {
  fetchCompanyFormList,
  fetchCompanyFormListClear,
} from "../actions/company";
import {
  fetchChangeStoreCustomer,
  fetchChangeTypeCustomer,
  fetchStoreFormList,
  fetchStoreFormListClear,
} from "../actions/store";

const CustomerList = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "customers";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];
  const { companyFormList } = useSelector((state) => state.companyReducer);
  const { storeFormList } = useSelector((state) => state.storeReducer);

  const { customerList } = useSelector((state) => state.customerReducer);
  const [showModal, setShowModal] = useState(false);
  const [points, setPoints] = useState(0);
  const [sector, setSector] = useState("");
  const [type, setType] = useState("add");
  const [fullName, setFullName] = useState(null);
  const [accountId, setAccountId] = useState(null);
  const [userData, setUserData] = useState(null);

  const [data, setData] = useState({
    company: "",
    store: "",
    position: "",
  });

  const [addPointsModal, setAddPointsModal] = useState(false);
  const [changeSectorModal, setChangeSectorModal] = useState(false);
  const [changeStoreModal, setChangeStoreModal] = useState(false);
  const [changeTypeModal, setChangeTypeModal] = useState(false);

  const submitAddPoints = () => {
    setShowModal(false);
    const items = {
      accountId: accountId,
      points: points,
      type: "ADMINISTRATOR",
    };

    dispatch(fetchAddPointsCustomer(items, type));
  };

  const modalTitleComputed = () => {
    console.log(userData, "userData");
    if (addPointsModal) {
      return `${t("customerList.addPointsTitle")} <b>${fullName ?? ""}</b>`;
    }

    if (changeSectorModal) {
      return `${t("customerList.changeSectorTitle")} <b>${fullName ?? ""}</b>`;
    }

    if (changeStoreModal) {
      return `Promena radnje prodavca <br/><b>${
        userData?.email ?? ""
      }</b> <br/><b>${userData?.storeName ?? ""}</b>`;
    }

    if (changeTypeModal) {
      return `Promena pozicije korisnika <b>${userData?.email ?? ""}</b>`;
    }

    return "";
  };

  const submitChangeSector = (data) => {
    setShowModal(false);
    const items = {
      accountId: accountId,
      sector: sector,
    };

    dispatch(fetchChangeSectorCustomer(items));
  };

  const submitChangeStore = (data) => {
    setShowModal(false);

    const items = {
      accountId: accountId,
      storeId: data.store,
    };

    dispatch(fetchChangeStoreCustomer(items));
  };

  const submitChangeType = (data) => {
    setShowModal(false);

    const items = {
      accountId: accountId,
      type: data?.position,
    };

    dispatch(fetchChangeTypeCustomer(items));
  };

  const actionSubmitComputed = () => {
    if (addPointsModal) {
      submitAddPoints();
    }

    if (changeSectorModal) {
      submitChangeSector();
    }

    if (changeStoreModal) {
      submitChangeStore(data);
    }

    if (changeTypeModal) {
      submitChangeType(data);
    }
  };

  const customCellRenderer = (params) => {
    if (
      !params.data ||
      !params.data.id ||
      !params.data.status ||
      !params.data.email
    )
      return null;
    return (
      <ButtonColumn
        deleteItemId={params.data.id}
        addPoints={params.data}
        editSector={params.data}
        editStore={params.data}
        editType={params.data}
        status={params.data.status}
        activeItemTitle={`${params.data.email}`}
        deactiveItemTitle={`${params.data.email}`}
        value={params}
        submitActionModal={handleSubmitModal}
        handleButtonAddPointsClick={handleButtonAddPointsClick}
        handleButtonChangeSectorClick={handleButtonChangeSectorClick}
        handleButtonChangeStoreClick={handleButtonChangeStoreClick}
        handleButtonChangeTypeClick={handleButtonChangeTypeClick}
      />
    );
  };

  const handleSubmitModal = (id, typeAction) => {
    typeAction == "deactive"
      ? dispatch(fetchDeactiveCustomer(id))
      : dispatch(fetchActiveCustomer(id));
  };

  const handleButtonAddPointsClick = (params) => {
    setFullName(params.email);
    setAccountId(params.id);
    setShowModal(true);
    setPoints(0);
    setType("add");
    setAddPointsModal(true);
    setChangeSectorModal(false);
    setChangeStoreModal(false);
    setChangeTypeModal(false);
  };

  const handleButtonChangeSectorClick = (params) => {
    setSector(params.sector);
    setFullName(params.name + " " + params.lastName);
    setAccountId(params.id);
    setShowModal(true);
    setAddPointsModal(false);
    setChangeStoreModal(false);
    setChangeTypeModal(false);
    setChangeSectorModal(true);
  };

  const handleButtonChangeStoreClick = (params) => {
    setShowModal(true);
    setChangeStoreModal(true);
    setAddPointsModal(false);
    setChangeTypeModal(false);
    setChangeSectorModal(false);
    setUserData(params);
    setAccountId(params?.id);
    setData({});

    dispatch(fetchCompanyFormList(params?.countryId));
  };

  const handleButtonChangeTypeClick = (params) => {
    setShowModal(true);
    setChangeTypeModal(true);
    setAddPointsModal(false);
    setChangeStoreModal(false);
    setChangeSectorModal(false);
    setUserData(params);
    setAccountId(params?.id);
  };

  useEffect(() => {
    dispatch(fetchCustomerList());
  }, [dispatch]);

  useEffect(() => {
    if (data?.company) dispatch(fetchStoreFormList(data?.company));
  }, [dispatch, data?.company]);

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("customerList.countryName"),
      field: "countryName",
      filter: "agSetColumnFilter",
      width: 150,
    },
    {
      headerName: t("customerList.status"),
      field: "status",
      filter: "agSetColumnFilter",
      width: 170,
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "INACTIVE":
            return t("customerList.inactive");
          case "ACTIVE":
            return t("customerList.active");
          default:
            return "";
        }
      },
    },
    {
      headerName: t("customerList.name"),
      field: "name",
      filter: "agTextColumnFilter",
      width: 180,
    },
    {
      headerName: t("customerList.lastName"),
      field: "lastName",
      filter: "agTextColumnFilter",
      width: 180,
    },
    {
      headerName: t("customerList.email"),
      field: "email",
      filter: "agTextColumnFilter",
      minWidth: 270,
      flex: 1,
    },
    {
      headerName: t("customerList.typeUser"),
      field: "accountType",
      filter: "agSetColumnFilter",
      cellRenderer: statusAdministrationRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.accountType) return null;
        switch (params.data.accountType) {
          case "BASIC_USER":
            return "Prodavac";
          case "MANAGER":
            return "Menadžer";
          default:
            return "";
        }
      },
    },
    {
      headerName: t("customerList.companyName"),
      field: "companyName",
      filter: "agSetColumnFilter",
    },
    {
      headerName: t("customerList.storeName"),
      field: "storeName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("customerList.sectorName"),
      field: "sector",
      filter: "agSetColumnFilter",
      cellRenderer: statusSectorRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.sector) return null;
        switch (params.data.sector) {
          case "DEVICE_FOR_HOUSE":
            return "Aparati za kuću";
          case "TV_AUDIO":
            return "TV/Audio";
          case "DEVICE_FOR_HOUSE_AND_TV_AUDIO":
            return "Aparati za kuću i TV/Audio";
          default:
            return "";
        }
      },
    },
    {
      headerName: t("customerList.levelName"),
      field: "levelName",
      filter: "agSetColumnFilter",
    },
    {
      headerName: t("customerList.levelDate"),
      field: "levelUpdateDate",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
      width: 280,
    },
    {
      headerName: t("customerList.points"),
      field: "points",
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("customerList.experience"),
      field: "experience",
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("customerList.phone"),
      field: "phone",
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("customerList.address"),
      field: "address",
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("customerList.createdAt"),
      field: "createdAt",
      filter: "agDateColumnFilter",
      cellStyle: { display: "flex", alignItems: "center" },
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      width: 180,
    },
  ];

  const setShowModalHandler = () => {
    setShowModal(!showModal);
    dispatch(fetchStoreFormListClear());
    dispatch(fetchCompanyFormListClear());
    setData({});
  };

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={customerList}
        columnDefs={columnDefs}
        gridStateKey={"customer-list"}
        // buttonLink={`/customer-add`}
        // buttonText={t(`breadcrumb.${translateModule}Add`)}
      />
      <CustomModal
        show={showModal}
        hideModal={() => setShowModalHandler(false)}
        modalTitle={modalTitleComputed()}
        actionSubmitModal={actionSubmitComputed}
      >
        <Fragment>
          {addPointsModal && (
            <div className="form-modal-add-points">
              <Row>
                <Col lg={12} className="">
                  <Alert severity="info" className="mb-3">
                    {t("customerList.infoAlert")}
                  </Alert>
                  <Row>
                    <Col lg={4}>
                      <FormControl fullWidth required size="small">
                        <InputLabel id="demo-simple-select-label">
                          Tip
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={type}
                          label="Tip"
                          name="type"
                          onChange={(e) => setType(e.target.value)}
                          size="small"
                        >
                          <MenuItem value="add">+ Dodaj</MenuItem>
                          <MenuItem value="remove">- Oduzmi</MenuItem>
                        </Select>
                      </FormControl>
                    </Col>
                    <Col lg={8}>
                      <InputField
                        type="number"
                        label={t("customerList.points")}
                        name="points"
                        required
                        size="small"
                        value={points}
                        onChange={(e) => setPoints(e.target.value)}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          )}
          {changeSectorModal && (
            <div className="form-modal-change-sector">
              <Col lg={12} md={12} xs={12}>
                <FormControl fullWidth required size="small">
                  <InputLabel id="demo-simple-select-label">
                    {t("global.sectorName")}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={sector}
                    label={t("global.sectorName")}
                    name="sector"
                    onChange={(e) => setSector(e.target.value)}
                    size="small"
                  >
                    <MenuItem value={"DEVICE_FOR_HOUSE"}>
                      {t("global.DEVICE_FOR_HOUSE")}
                    </MenuItem>
                    <MenuItem value={"TV_AUDIO"}>
                      {t("global.TV_AUDIO")}
                    </MenuItem>
                    <MenuItem value={"DEVICE_FOR_HOUSE_AND_TV_AUDIO"}>
                      {t("global.DEVICE_FOR_HOUSE_AND_TV_AUDIO")}
                    </MenuItem>
                  </Select>
                </FormControl>
              </Col>
            </div>
          )}
          {changeTypeModal && (
            <div className="form-modal-change-sector">
              <Col lg={12} md={12} xs={12}>
                <FormControl fullWidth required size="small">
                  <InputLabel id="demo-simple-select-label">
                    Pozicija
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={data?.position}
                    label="Pozicija"
                    name="position"
                    size="small"
                    onChange={(e) =>
                      setData({ ...data, position: e.target.value })
                    }
                  >
                    <MenuItem value={"BASIC_USER"}>Prodavac</MenuItem>
                    <MenuItem value={"MANAGER"}>Menadžer</MenuItem>
                  </Select>
                </FormControl>
              </Col>
            </div>
          )}
          {changeStoreModal && (
            <div className="form-modal-change-sector">
              <Col lg={12} md={12} xs={12}>
                <FormControl fullWidth required size="small">
                  <InputField
                    type="input"
                    label={"Država"}
                    size="small"
                    value={userData?.countryName}
                    disabled
                  />
                </FormControl>
              </Col>
              <Col lg={12} md={12} xs={12}>
                <FormControl fullWidth required size="small" className="mt-3">
                  <InputLabel id="demo-simple-select-label">
                    Kompanija
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={data?.company}
                    label="Kompanija"
                    name="company"
                    size="small"
                    onChange={(e) =>
                      setData({ ...data, company: e.target.value })
                    }
                  >
                    {companyFormList.map((item) => (
                      <MenuItem value={item.id}>{item.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Col>
              <Col lg={12} md={12} xs={12}>
                <FormControl fullWidth required size="small" className="mt-3">
                  <InputLabel id="demo-simple-select-label">Radnja</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={data?.store}
                    label="Radnja"
                    name="store"
                    size="small"
                    disabled={!data?.company}
                    onChange={(e) =>
                      setData({ ...data, store: e.target.value })
                    }
                  >
                    {storeFormList.map((item) => (
                      <MenuItem value={item.id}>{item.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Col>
            </div>
          )}
        </Fragment>
      </CustomModal>
    </Fragment>
  );
};

export default CustomerList;
